import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'lable-popup',
  // templateUrl: 'footer-total.html'
  template: require('./lable-popup.html'),
  styles: [`
  .lable-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 0 0 6px;
    background-color: #f8f9fa;
}

.lable-item {
  display: flex;
  align-items: center;
  margin: 0 15px 0 0;
}

.lable-key {
  font-weight: bold;
  margin-right: 8px;
  font-size: 13px;
  color:rgb(56 132 193) !important;
}

.lable-value {
  font-weight: bold;
  color: rgb(233 28 136) !important;
  font-size: 13px;
}

  `]
})
export class LablePopupComponent implements OnInit {
  @Input() LableData: { key: string, value: any, isVisible:boolean } [ ] = [];
  constructor() { }

  ngOnInit() {
    console.log('lablePopupComponent');
  }

}